<div class="detail-content__ods" *ngIf="isOdsActive">
    <div *ngIf="ods.length >= 1">
      <h3 class="detail-content__ods-title bold">{{ 'CARD_DETAIL.ODS_TITLE' | translate }}</h3>
      <div class="ods-container">
        <div class="d-flex" *ngFor="let element of ods; let i = index">
          <a (mouseover)="odsClass[i]='ods_img_big'" (mouseout)="odsClass[i]='ods_img_little'">
            <img [ngClass]="odsClass[i]" src="assets/img/ods/es/{{element.name}}.png" width="129" height="129">
          </a>
        </div>
      </div>
    </div>
</div>  